import {AfterContentInit, Component, Input, OnDestroy, OnInit, ViewContainerRef} from '@angular/core';
import {MdDialog, MdDialogConfig, MdDialogRef} from '@angular/material';
import {AuthGuard} from '../../../auth/auth.guard';
import {PreferedAllocationService} from '../../../shared/prefered-allocation.service';
import {InterpreterPopupComponent} from '../../../shared/ui/interpreter-popup/interpreter-popup.component';

@Component({
  selector: 'app-add-interpreters',
  templateUrl: './add-interpreters.component.html',
  styleUrls: ['./add-interpreters.component.sass'],
})
export class AddInterpretersComponent implements OnInit, AfterContentInit, OnDestroy {
  @Input() isPreferred = false;
  @Input() isReadOnly = false;
  @Input() selectedInterpreters = [];
  needInterpreter = false;
  private dialogSub: any;
  dialogRef: MdDialogRef<any>;
  title = '';
  @Input() isUserPage = false;
  @Input() isHidden = false;
  @Input() isEditable = true;
  @Input() state_where_most_bookings_occur = 'VIC';
  preferAllocSub: any;

  constructor(
    public dialog: MdDialog,
    public viewContainerRef: ViewContainerRef,
    private _sharedPreferedAllocationService: PreferedAllocationService
  ) {}

  ngOnInit() {
    this.title = this.isPreferred ? 'PREFFERED INTERPRETER' : 'BLOCKED INTERPRETER';
    this.preferAllocSub = this._sharedPreferedAllocationService.interpreterStream$.subscribe((data) => {
      this.selectedInterpreters = data;
    });
  }

  ngOnDestroy() {
    let sub = this.preferAllocSub && this.preferAllocSub.unsubscribe();
    return sub;
  }

  ngAfterContentInit() {
    this.needInterpreter = this.isHidden;
    if (this.isUserPage && this.isPreferred) {
      this.needInterpreter = this.selectedInterpreters.filter((inter) => inter.preference === 'preferred').length > 0;
    } else if (this.isUserPage && !this.isPreferred) {
      this.needInterpreter = this.selectedInterpreters.filter((inter) => inter.preference === 'blocked').length > 0;
    }
  }

  checkInterpreterPreference(interpreter) {
    return interpreter.preference === (this.isPreferred ? 'preferred' : 'blocked');
  }

  manageInterpreter() {
    if (this.isReadOnly) {
      return;
    }
    if (this.dialogSub) {
      this.dialogSub.unsubscribe();
    }

    let config: MdDialogConfig = {
      disableClose: true,
    };
    config.viewContainerRef = this.viewContainerRef;
    this.dialogRef = this.dialog.open(InterpreterPopupComponent, config);
    this.dialogRef.componentInstance.selectedInterpreters = this.selectedInterpreters;
    this.dialogRef.componentInstance.isPreffered = this.isPreferred;
    this.dialogRef.componentInstance.state_where_most_bookings_occur = this.state_where_most_bookings_occur;
    this.dialogSub = this.dialogRef.afterClosed().subscribe((result) => {
      this._sharedPreferedAllocationService.publishData(this.selectedInterpreters);
    });
  }

  removeInterpreter(selectedInterpreter) {
    if (this.isReadOnly) {
      return;
    }
    if (AuthGuard.isLoggedIn()) {
      selectedInterpreter._destroy = 1;
    } else {
      this.selectedInterpreters = this.selectedInterpreters.filter(
        (i) => i.interpreter_id !== selectedInterpreter.interpreter_id
      );
    }
    this._sharedPreferedAllocationService.publishData(this.selectedInterpreters);
  }
}



// WEBPACK FOOTER //
// ./src/app/booking-management/booking-form/add-interpreters/add-interpreters.component.ts